<nav class="navbar nav-bar-expand-md navbar-dark bg-dark mb-4"> <a class="navbar-brand"
        href="http://iowadot.gov"><img alt="Iowa Logo" src="./assets/Iowa-DOT-logo_horizontal_white.png" class="header-logo" /><span
            class="header-text">Video Request Form</span></a></nav>
<div class="container">
    <div *ngIf="isComplete">
        <div class="row text-center">
            <h2 [ngClass]="{'text-danger': isError}" class="complete">{{successMsg}}</h2>
        </div>
        <div class="row justify-content-sm-center">
            <div class="col col-md-3"> <button type="button" class="btn btn-success" (click)="onNewForm()">Start
                    Over</button> </div>
        </div>
    </div>
    <div *ngIf="!isComplete"> 
        <esri-map (mapLoadedEvent)="mapLoadedEvent($event)"
            (pickedCameraEvent)="pickedCameraEvent($event)" #esriMap [isMobile]="isMobile"></esri-map>
        <div *ngIf="!isValidate">
            <form [formGroup]="exampleForm" (ngSubmit)="onSubmit()" novalidate>
                <div class="row">
                    <div class="col-12">
                       <div class="card">
                            <div class="card-header">
                                <h3>Requestor Information</h3>
                            </div>
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="form-group col-md-6"> <label for="personName"><span
                                                class="text-danger">* </span>First and last
                                            name</label> <input type="text" class="form-control" id="personName"
                                            required formControlName="personName" [ngClass]="{'is-invalid':
                                            personName?.invalid && personName?.touched}" />
                                        <div class="invalid-feedback" *ngIf="personName?.invalid && personName?.touched"> <!--&& personName?.errors?['dualName']-->
                                            Must provide first and last name.
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6"> <label for="company">Company or
                                            agency</label> <input type="text" class="form-control"
                                            formControlName="company" /> </div>
                                    <div class="form-group col-md-6"> <label for="userType"><span
                                                class="text-danger">* </span>I am a </label> <select
                                            formControlName="userType" class="form-control" required
                                            [ngClass]="{'is-invalid': userType?.invalid && userType?.dirty}">
                                            <option value="-1" selected>-- Select One --</option>
                                            <option value="0">Attorney</option>
                                            <option value="1">DOT Consultant
                                            </option>
                                            <option value="2">Government agency</option>
                                            <option value="3">Insurance company</option>
                                            <option value="4">Law
                                                enforcement</option>
                                            <option value="5">Media</option>
                                            <option value="6">Private citizen</option>
                                        </select>
                                        <div class="invalid-feedback" *ngIf="userType?.invalid && userType?.dirty">
                                            Must select type </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <div class="form-check" *ngIf="userType?.value==4" style="margin-top: 35px;
                                            margin-left: 10px;"> <input class="form-check-input" type="checkbox"
                                                formControlName="isUrgent"> <label class="form-check-label"
                                                for="isUrgent"> Urgent: Footage needed within 1 business day
                                            </label> </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="email"><span class="text-danger">* </span>Email</label>
                                        <input type="email" formControlName="email" class="form-control"
                                            [ngClass]="{'is-invalid': email?.invalid && email?.touched}" required />
                                        <div class="invalid-feedback" *ngIf="email?.invalid && email?.touched &&
                                            email?.errors"> Must provide valid email. </div>
                                    </div>
                                    <div class="form-group col-md-6"> <label for="phone"><span
                                                class="text-danger">* </span>Daytime Phone Number</label> <input
                                            type="tel" formControlName="phone" mask="(000) 000-0000"
                                            class="form-control" [ngClass]="{'is-invalid': phone?.invalid &&
                                            phone?.touched}" required />
                                        <div class="invalid-feedback" *ngIf="phone?.invalid && phone?.touched"> Must
                                            provide valid phone
                                            number. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3>Video Request Information</h3>
                            </div>
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="col-md-12">
                                        <h4>
                                            Selected Cameras</h4>
                                        <p>Please go back to the map if you need to change
                                            this list.</p>
                                    </div>
                                    <div class="col-md-12">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Camera Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let cam of pickedCameras; let i=index">
                                                    <td scope="row">{{i + 1}}</td>
                                                    <td>
                                                        {{cam.attributes['Desc_']}}</td>
                                                </tr>
                                                <tr *ngIf="pickedCameras.length==0">
                                                    <td colspan="2" class="text-danger">No cameras selected</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6"> <label for="isFatality"><span
                                                class="text-danger">* </span>Is there a known fatality involved with
                                            this incident?</label> <select formControlName="isFatality"
                                            class="form-control" required>
                                            <option value="">-- Select One --
                                            </option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No
                                            </option>
                                            <option value="Possibly">Possibly</option>
                                        </select>
                                    </div>
                                    <div class="w-100"></div>
                                    <div class="form-group col-md-6">
                                        <label for="reason"><span class="text-danger">* </span>What are you looking
                                            for in the video?</label> <textarea formControlName="reason"
                                            placeholder="" cols="40" rows="3" class="form-control"
                                            [ngClass]="{'is-invalid': reason?.invalid && reason?.touched}"
                                            required></textarea>
                                        <div class="invalid-feedback" *ngIf="reason?.invalid && reason?.touched"> The
                                            description has to be
                                            atleast 5 characters. </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="dateStart timeStart"><span
                                                    class="text-danger">* </span>Start Date and Time</label>
                                            <!--<div *ngIf="!isMobile"> <input type="text" formControlName="dateStart"
                                                    class="form-control" placeholder="mm/dd/yyyy" bsDatepicker />
                                            </div>-->
                                            <div class="mb-2"> <input type="date" formControlName="dateStart"
                                                    class="form-control" placeholder="mm/dd/yyyy" /> </div> <!--*ngIf="isMobile"-->
                                        </div>
                                        <div class="form-group">
                                            <!--<div *ngIf="!isMobile">
                                                <timepicker [formControlName]="'timeStart'" [minuteStep]="1" >
                                                </timepicker>
                                            </div>-->
                                            <div> <input type="time" formControlName="timeStart" 
                                                    class="form-control" /> </div><!--*ngIf="isMobile"-->
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group"> <label for="timeEnd dateEnd"><span
                                                    class="text-danger">* </span>End Date
                                                and Time</label>
                                         <!--  <div *ngIf="!isMobile"> 
                                               <!-- <input type="text" formControlName="dateEnd" class="form-control" placeholder="mm/dd/yyyy" bsDatepicker /> 
                                                <input class="form-control" matInput [matDatepicker]="picker">
                                                <mat-hint>MM/DD/YYYY</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </div> -->
                                            <div class="mb-2"> <input type="date" formControlName="dateEnd"
                                                    class="form-control" placeholder="mm/dd/yyyy" /> </div> <!--*ngIf="isMobile"-->
                                        </div>
                                        <div class="form-group">
                                           <!--<div *ngIf="!isMobile">
                                                <ngb-timepicker [formControlName]="'timeStart'" [minuteStep]="1"> 
                                                </ngb-timepicker>
                                            </div>-->
                                            <div> <input type="time" formControlName="timeEnd"
                                                    class="form-control" /> </div><!--*ngIf="isMobile"-->
                                        </div>
                                    </div>
                                    <div class="col mt-2"> <button type="submit" class="btn btn-success"
                                            [disabled]="!exampleForm.valid" style="margin-bottom: 5px;">Review
                                            Request</button>
                                        <p *ngIf="!exampleForm.valid"><em>Button will remain
                                                inactive until all required fields are complete.</em></p>
                                        <p *ngIf="exampleForm.valid"><em>Please click the Review button. All required
                                                fields are complete.</em></p>
                                    </div>
                                </div>
                            </div>
                        </div> <!-- card -->
                    </div> <!-- col-12 -->
                </div><!-- row -->
                <div class="row">
                    <div class="col-12">
                        <p> <b>NOTE: Recordings are only kept for 7 days, but if you’re request is past that,
                             please still submit your request - the video may be available if someone else
                              requested it during that time.</b><br /> If you're experiencing problems with this form, please email
                            <a href="mailto:DOT-CameraVidReq@iowadot.us">DOT-CameraVidReq@iowadot.us</a>.
                        </p>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="isValidate">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3>Verify Information</h3>
                        </div>
                        <div class="card-body">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <p> <b>First and
                                            last Name:</b> {{personName?.value}} <br /><b>Company or agency:</b>
                                        {{company?.value}} <br /><b>I am a:</b> {{userTypeName}} <span
                                            *ngIf="isUrgent?.value" class="text-danger"><br /><b>Urgent:</b> Footage
                                            needed within 24 hours</span> <br /><b>Email:</b> {{email?.value}}
                                        <br /><b>Day Time Phone Number:</b> {{phone?.value}} <!-- | mask: '(000) 000-0000' -->
                                        <br /><b>Selected cameras:</b>
                                    </p>
                                    <ul>
                                        <li *ngFor="let cam of pickedCameras; let i=index">
                                            {{cam.attributes['Desc_']}}</li>
                                    </ul>
                                    <p> <b>Is there a known fatality involved with this incident?:</b>
                                        {{isFatality}} <br /><b>What are you looking for in the video?:</b>
                                        {{reason?.value}} <br /><b>Start Date and Time:</b> {{startDateTime |
                                        date:'short'}} <br /><b>End Date and Time:</b> {{endDateTime |
                                        date:'short'}} </p> <button (click)="onValidate(false)" class="btn btn-info"
                                        style="margin-right: 10px;">Go Back</button> <button
                                        (click)="disableSubmit=true; onValidate(true);" class="btn btn-primary"
                                        [disabled]="disableSubmit">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> <!--<router-outlet></router-outlet> -->
</div>
